import TipsBar from './tips-bar'
import EndBt from './end-bt'
import NoticeBar from './notice-bar'
import NavBar from './nav-bar'
export default [TipsBar, EndBt, NoticeBar, NavBar]
